import { FormattedMessage, injectIntl } from "react-intl";
import { allowMultiLanguage } from "@lib/constants/AppConst";
import PropTypes from "prop-types";

const InjectMassage = (props: any) => {
  if (allowMultiLanguage) {
    return <FormattedMessage {...props} />;
  } else {
    return props.id.split(".").pop();
  }
};

InjectMassage.propTypes = {
  id: PropTypes.string,
};

export default injectIntl(InjectMassage, {
  forwardRef: false,
});

export function getRangeStartSuffix(locale, number: number): string {
  if (locale.startsWith("tr")) {
    return getTurkishSuffix(number, "from");
  }

  return locale;
}

export function getRangeEndSuffix(locale, number: number): string {
  if (locale.startsWith("tr")) {
    return getTurkishSuffix(number, "to");
  }

  return locale;
}

function getTurkishSuffix(number: number, type: "from" | "to"): string {
  const lastDigit = number % 10;
  const lastTwoDigits = number % 100;

  if (type === "from") {
    if ([3, 4, 5].includes(lastDigit) || [70].includes(lastTwoDigits)) {
      return "ten";
    } else if ([].includes(lastDigit) || [40, 60].includes(lastTwoDigits)) {
      return "tan";
    } else if (
      [6, 9].includes(lastDigit) ||
      [10, 30, 90].includes(lastTwoDigits)
    ) {
      return "dan";
    } else {
      return "den";
    }
  }

  // type to
  if ([2, 7].includes(lastDigit) || [20, 50].includes(lastTwoDigits)) {
    return "ye";
  } else if ([6].includes(lastDigit)) {
    return "ya";
  } else if (
    [9].includes(lastDigit) ||
    [10, 30, 40, 60, 90].includes(lastTwoDigits)
  ) {
    return "a";
  } else {
    return "e";
  }
}
